import ProgramSignupPage from './ProgramSignup/ProgramSignupPage'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useUrlSearchParam } from '@/hooks'

const useRedirectToWhiteLabelIfNeeded = () => {
  const { utility } = useParams<{ utility?: string }>()
  if (utility !== undefined) return
  const listing = useUrlSearchParam('listing')
  if (!listing) return
  const location = useLocation()
  const history = useHistory()
  history.replace(`/${listing}${location.pathname}`)
}

type SignUpProps = {
  initialMode?: 'signup' | 'login' | 'impersonate'
}

export default function SignUp({ initialMode }: SignUpProps = {}) {
  useRedirectToWhiteLabelIfNeeded()
  const location = useLocation()
  const { programId } = useParams<{ programId?: string }>()
  const programIdNum =
    programId != null && programId !== '' ? parseInt(programId, 10) : null
  const isValidProgramId =
    programIdNum != null && !Number.isNaN(programIdNum) && programIdNum > 0

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY ?? ''}
    >
      <ProgramSignupPage
        key={location.pathname}
        programId={isValidProgramId ? programIdNum : null}
        initialMode={initialMode}
      />
    </GoogleReCaptchaProvider>
  )
}
